<template>
  <div class="expanded-menu">
    <div class="close-btn hub-close-normal clickable" @click="fold" @keypress.enter="fold">
      <inline-svg :src="$assets.svg['icon-close']" width="100%" height="100%" />
    </div>

    <!-- Top logo -->
    <div id="menuLogo" class="logo-svg-normal">
      <img class="logo" :src="$assets.image['HUB_Logo_Col.png']" alt="HUB Logo" />
    </div>

    <ul class="menu-list">
      <!-- Learning types -->
      <li
        v-for="learningType in learningTypes"
        :key="learningType.id"
        class="clickable"
        :class="{ active: currentFunction.key === learningType.learning_type_key }"
        @click="goToLearn(learningType)"
        @keypress.enter="goToLearn(learningType)"
      >
        <inline-svg :src="$path.resolveImage(learningType.image)" height="40%" />
        <div class="text">{{ learningType.name }}</div>
      </li>

      <!-- Other services --><!-- TODO: read services from server api -->
      <li
        class="clickable"
        :class="{ active: currentFunction.key === 'client-service' }"
        @click="goClientList"
        @keypress.enter="goClientList"
      >
        <inline-svg :src="$assets.svg['icon-client-list']" height="40%" />
        <div class="text">Client List</div>
      </li>

      <!-- Fill the space between -->
      <li class="bottom-items-start" />

      <!-- System(static) services -->
      <li
        class="clickable"
        :class="{ active: currentFunction.key === 'profile' }"
        @click="goProfile"
        @keypress.enter="goProfile"
      >
        <inline-svg :src="$assets.svg['icon-profile']" height="40%" />
        <div class="text">Profile</div>
      </li>

      <li class="clickable" @click="logout" @keypress.enter="logout">
        <inline-svg :src="$assets.svg['icon-logout']" height="40%" />
        <div class="text">Logout</div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';

import $assets from '@/assets';
import useSessionStore from '@/stores/session';
import $api from '@/utils/api';
import $path from '@/utils/path';

const emit = defineEmits(['fold', 'goToLearn', 'goClientList', 'goProfile', 'logout']);
const SessionStore = useSessionStore();
const learningTypes = ref([]);

onMounted(async () => {
  const data = await $api.get('/learning-types');
  learningTypes.value = data.records.filter(
    (learningType) => learningType.is_ui_gate && learningType.learning_type_status === 'available'
  );
});

const currentFunction = computed(() => {
  return SessionStore.HUBSettings.currentFunction;
});

function fold() {
  emit('fold');
}

function goToLearn(learningType) {
  emit('goToLearn', learningType);
}

function goClientList() {
  emit('goClientList');
}

function goProfile() {
  emit('goProfile');
}

function logout() {
  emit('logout');
}
</script>

<script>
export default {
  name: 'ExpandedMenu',
};
</script>
